import React from 'react'

const AuthCollage = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="111"
    height="96"
    fill="none"
    viewBox="0 0 111 96"
  >
    <g clipPath="url(#clip0_2902_348)">
      <circle
        cx="55.2"
        cy="48"
        r="48"
        fill="url(#paint0_linear_2902_348)"
      ></circle>
      <path
        stroke="#004B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.281"
        d="M100.067 74.546h2.957"
      ></path>
      <path
        stroke="#004B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.281"
        d="M83.805 67.395a.24.24 0 0 1 .24-.24h21.695a.24.24 0 0 1 .241.24v9.868a.24.24 0 0 1-.241.24H84.045a.24.24 0 0 1-.24-.24z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#004B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.281"
        d="m90.457 70.85-3.696 3.696M90.457 74.546l-3.696-3.696M97.11 70.85l-3.696 3.696M97.11 74.546l-3.696-3.696"
      ></path>
      <path
        stroke="#004B4E"
        strokeWidth="0.721"
        d="M87.116 31.767a.2.2 0 0 1-.118-.193q0-.134.059-.251a12.45 12.45 0 0 1 4.647-3.937 13.4 13.4 0 0 1 6.008-1.391q3.197 0 6.023 1.361a12.4 12.4 0 0 1 4.691 3.907q.089.15.074.237a.34.34 0 0 1-.103.178.3.3 0 0 1-.222.088q-.134 0-.252-.147a11.6 11.6 0 0 0-4.454-3.73 13.1 13.1 0 0 0-5.757-1.302q-3.049 0-5.712 1.317a12.16 12.16 0 0 0-4.44 3.715q-.118.147-.222.177a.3.3 0 0 1-.222-.03Zm14.118 14.887q-3.048-.77-5.017-3.049-1.968-2.279-1.968-5.534 0-1.392 1.021-2.338t2.442-.947 2.442.947a3.06 3.06 0 0 1 1.021 2.338q0 1.125.873 1.894.873.77 2.027.77 1.125 0 1.969-.77.843-.77.843-1.894 0-3.641-2.708-6.097t-6.467-2.457q-3.76 0-6.467 2.457-2.708 2.456-2.708 6.097 0 .71.162 1.85.163 1.14.696 2.59.06.147 0 .221a.7.7 0 0 1-.148.134.37.37 0 0 1-.251.03q-.134-.03-.193-.178a17 17 0 0 1-.607-2.294 12.6 12.6 0 0 1-.222-2.353q0-3.819 2.901-6.526 2.901-2.709 6.837-2.709 4.025 0 6.911 2.664t2.886 6.57q0 1.362-1.007 2.31-1.005.946-2.427.947-1.45 0-2.486-.948-1.035-.946-1.036-2.308 0-1.155-.843-1.924a2.87 2.87 0 0 0-1.998-.77q-1.154 0-2.013.77a2.48 2.48 0 0 0-.858 1.924q0 3.078 1.865 5.135t4.646 2.886q.178.06.222.148a.3.3 0 0 1 .015.207q-.029.148-.118.207-.089.06-.237 0Zm-10.448-21.31q-.148.06-.222.015a.4.4 0 0 1-.133-.134q-.06-.058-.06-.177a.2.2 0 0 1 .09-.178 15.3 15.3 0 0 1 3.537-1.39 15 15 0 0 1 3.714-.474q1.923 0 3.774.473 1.85.474 3.537 1.332.147.06.162.178a.3.3 0 0 1-.044.207.5.5 0 0 1-.163.148q-.104.06-.251 0a18 18 0 0 0-3.404-1.258 14.4 14.4 0 0 0-3.611-.459 15 15 0 0 0-3.581.43 14.2 14.2 0 0 0-3.345 1.287Zm3.966 20.984q-1.716-1.775-2.678-3.729-.963-1.953-.962-4.528 0-2.634 1.938-4.44 1.94-1.805 4.662-1.805t4.691 1.805q1.968 1.806 1.968 4.44 0 .148-.074.222-.073.075-.222.074a.36.36 0 0 1-.236-.074q-.09-.074-.089-.222 0-2.397-1.791-4.025t-4.247-1.628-4.218 1.628q-1.76 1.628-1.76 4.025 0 2.516.872 4.291.874 1.776 2.59 3.552.12.12.104.222a.34.34 0 0 1-.104.192.5.5 0 0 1-.192.104q-.134.045-.252-.104Zm9.057-2.16q-2.604 0-4.514-1.732-1.909-1.732-1.909-4.365 0-.148.074-.237.075-.09.222-.089.148 0 .222.089.075.09.074.237 0 2.397 1.761 3.951t4.07 1.554q.237 0 .562-.03t.711-.088q.147-.03.237.044.088.074.118.163a.3.3 0 0 1-.015.207q-.044.09-.192.118a4 4 0 0 1-.933.163q-.4.015-.488.015Z"
      ></path>
      <g
        stroke="#004B4E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.428"
        clipPath="url(#clip1_2902_348)"
      >
        <path d="M24.968 49.593v2.922a1.46 1.46 0 0 1-1.461 1.461h-2.923M20.585 32.059h2.922a1.46 1.46 0 0 1 1.461 1.46v2.923M3.05 36.442V33.52a1.46 1.46 0 0 1 1.462-1.461h2.922M7.434 53.976H4.512a1.46 1.46 0 0 1-1.462-1.46v-2.923M14.01 44.113a4.018 4.018 0 1 0 0-8.036 4.018 4.018 0 0 0 0 8.036M20.21 49.959a6.576 6.576 0 0 0-12.401 0"></path>
      </g>
      <path
        fill="#004B4E"
        d="M53.937 47.919a5.612 5.612 0 1 0 0-11.225 5.612 5.612 0 0 0 0 11.225M68.903 47.919a4.365 4.365 0 1 0-6.236 3.928v6.673l1.87 1.87 3.119-3.117-1.871-1.871 1.87-1.87-1.546-1.547a4.365 4.365 0 0 0 2.794-4.066m-4.365 0a1.247 1.247 0 1 1 0-2.495 1.247 1.247 0 0 1 0 2.495M58.85 50.438a7.5 7.5 0 0 0-3.043-.648h-3.741a7.483 7.483 0 0 0-7.483 7.483v2.494h16.213v-6.872a6.44 6.44 0 0 1-1.945-2.457"
      ></path>
      <rect
        width="35.844"
        height="65.475"
        x="38.473"
        y="15.42"
        stroke="#004B4E"
        strokeLinejoin="round"
        strokeWidth="2.39"
        rx="1.673"
      ></rect>
    </g>
    <defs>
      <clipPath id="clip0_2902_348">
        <path fill="#fff" d="M0 0h110.4v96.001H0z"></path>
      </clipPath>
      <clipPath id="clip1_2902_348">
        <path fill="#fff" d="M2.32 31.328h23.379v23.379H2.32z"></path>
      </clipPath>
      <linearGradient
        id="paint0_linear_2902_348"
        x1="7.2"
        x2="103.2"
        y1="48"
        y2="48"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BCEDFA"></stop>
        <stop offset="1" stopColor="#BFEFF2"></stop>
      </linearGradient>
    </defs>
  </svg>
)

export default AuthCollage
